var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F70808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.375L8.06625 5.0715C7.9605 5.256 7.77094 5.23912 7.58081 5.13619L6.90581 4.79475L7.40869 7.40081C7.515 7.87725 7.17525 7.87725 7.00762 7.67081L5.8275 6.38438L5.63625 7.038C5.61375 7.12406 5.517 7.21406 5.37131 7.19269L3.88069 6.88669L4.27162 8.27494C4.356 8.58375 4.42125 8.71144 4.18725 8.79244L3.65569 9.03656L6.22237 11.0683C6.27339 11.1071 6.31174 11.1601 6.33257 11.2207C6.3534 11.2813 6.35577 11.3467 6.33937 11.4086L6.11437 12.1275C6.99862 12.0279 7.79062 11.8789 8.67487 11.7866C8.75306 11.7788 8.88356 11.9042 8.883 11.9925L8.76656 14.625H9.19631L9.12881 11.9981C9.12825 11.9098 9.24693 11.7788 9.32456 11.7866C10.2088 11.8789 11.0008 12.0285 11.8845 12.1275L11.6601 11.4086C11.6436 11.3467 11.6459 11.2813 11.6668 11.2207C11.6876 11.1601 11.726 11.107 11.7771 11.0683L14.3437 9.03656L13.8122 8.793C13.5782 8.71144 13.6434 8.58375 13.7278 8.27494L14.1193 6.88669L12.6281 7.19269C12.4824 7.21406 12.3851 7.12406 12.3637 7.038L12.1719 6.38438L10.9924 7.67137C10.8247 7.87725 10.485 7.87725 10.5913 7.40137L11.0947 4.79475L10.4192 5.13619C10.2291 5.23912 10.0395 5.256 9.93375 5.0715L9 3.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdn);
export default __webpack_public_path__ + "static/media/cdn.b848e42e7c6393bb2693885ebfc9cec0.svg";
export { ForwardRef as ReactComponent };